const en = {
    // ─── Auth ───────────────────────────────────────────────────────────────
    auth: {
        welcomeBack: 'Welcome back',
        signInTo: 'Sign in to your account',
        signIn: 'Sign in',
        signingIn: 'Signing in...',
        createAccount: 'Create your account',
        getStarted: 'Get started with RouteWise',
        createAccountBtn: 'Create account',
        creatingAccount: 'Creating account...',
        dontHaveAccount: "Don't have an account?",
        alreadyHaveAccount: 'Already have an account?',
        email: 'Email Address',
        emailPlaceholder: 'you@company.com',
        password: 'Password',
        passwordPlaceholder: 'Your password',
        passwordHint: 'At least 6 characters',
        confirmPassword: 'Confirm Password',
        confirmPasswordPlaceholder: 'Confirm your password',
        yourName: 'Your Name',
        namePlaceholder: 'John Smith',
        companyName: 'Company Name',
        companyPlaceholderHvac: 'ABC HVAC Services',
        companyPlaceholderConstruction: 'ABC Construction Co.',
        phoneNumber: 'Phone Number',
        phonePlaceholder: '501234567',
        fullNumber: 'Full number:',
        industryQuestion: 'What industry are you in?',
        hvacDesc: 'Heating, cooling & ventilation',
        constructionDesc: 'Building & infrastructure',
        passwordsNoMatch: 'Passwords do not match',
        passwordTooShort: 'Password must be at least 6 characters',
        selectIndustry: 'Please select your industry',
    },

    // ─── Dashboard ──────────────────────────────────────────────────────────
    dashboard: {
        dispatchNeedsTechnician: '{{count}} jobs need a technician',
        dispatchWaiting: '{{count}} waiting for the technician to accept',
        dispatchCta: 'Assign now',
        title: 'Dashboard',
        welcome: 'Welcome back,',
        companyCodeLabel: 'Company Code',
        companyCodeDesc: 'Share this with your {{workers}} so they can join on mobile',
        copy: 'Copy',
        copied: 'Copied!',

        // HVAC stats
        totalJobs: 'Total Jobs',
        scheduledToday: 'Scheduled Today',
        customers: 'Customers',

        // Construction stats
        activeProjects: 'Active Projects',
        scheduled: 'scheduled',
        completed: 'Completed',
        thisQuarter: 'this quarter',
        totalProjects: 'Total Projects',
        allTime: 'all time',

        // Panels
        todaySchedule: "Today's Schedule",
        noJobsToday: 'No jobs scheduled for today',
        scheduleAJob: 'Schedule a job',
        viewAll: 'View all →',

        activeWorkers: 'Active {{workers}}',
        noWorkersYet: 'No {{workers}} added yet',

        // Quick Actions
        quickActions: 'Quick Actions',
        addCustomer: 'Add Customer',
        addCustomerSub: 'Add a new customer record',
        createA: 'Create a new',
        newServiceCall: 'New Service Call',
        newServiceCallSub: 'Create a service call from an incoming phone call',

        // Worker statuses
        available: 'Available',
        onsite: 'On-site',
        offline: 'Offline',

        // Revenue board
        revenue: {
            title: 'Revenue Overview',
            totalRevenue: 'Total Revenue',
            thisMonth: 'This Month',
            thisWeek: 'This Week',
            avgJobValue: 'Avg Job Value',
            monthlyTrend: 'Monthly Trend',
            noData: 'No revenue data yet',
            currency: '₪',
        },
    },

    // ─── Industry-specific labels ───────────────────────────────────────────
    industry: {
        hvac: {
            workers: 'Technicians',
            workerSingle: 'Technician',
            jobs: 'Jobs',
            jobSingle: 'Job',
            newJob: 'New Job',
            addWorker: 'Add Technician',
            registerWorker: 'Register a new technician',
        },
        construction: {
            workers: 'Workers',
            workerSingle: 'Worker',
            jobs: 'Projects',
            jobSingle: 'Project',
            newJob: 'New Project',
            addWorker: 'Add Worker',
            registerWorker: 'Register a new worker',
        },
    },

    // ─── Navigation ─────────────────────────────────────────────────────────
    nav: {
        dashboard: 'Dashboard',
        projects: 'Projects',
        jobs: 'Jobs',
        workers: 'Workers',
        technicians: 'Technicians',
        customers: 'Customers',
        routes: 'Routes',
        leads: 'Leads',
        schedule: 'Schedule',
        reports: 'Reports',
        settings: 'Settings',
        help: 'Help',
        logout: 'Logout',
    },

    // ─── Customers ──────────────────────────────────────────────────────────
    customers: {
        title: 'Customers',
        addCustomer: '+ Add Customer',
        searchPlaceholder: 'Search customers...',
        noCustomers: 'No customers found. Add your first customer!',
        loading: 'Loading customers...',
        deleteConfirm: 'Are you sure you want to delete this customer?',
        failedCreate: 'Failed to create customer',
        failedUpdate: 'Failed to update customer',
        failedDelete: 'Failed to delete customer',
        editCustomer: 'Edit Customer',
        addNewCustomer: 'Add New Customer',
        name: 'Name *',
        phone: 'Phone *',
        email: 'Email',
        address: 'Address *',
        addressPlaceholder: '123 Main St, City, State',
        notes: 'Notes',
        cancel: 'Cancel',
        update: 'Update',
        add: 'Add',
        customer: 'Customer',
    },

    // ─── Workers ────────────────────────────────────────────────────────────
    workers: {
        title: 'Workers',
        addWorker: '+ Add Worker',
        showActiveOnly: 'Show active only',
        noWorkers: 'No workers found. Add your first worker!',
        loading: 'Loading workers...',
        deleteConfirm: 'Are you sure you want to delete this worker?',
        failedCreate: 'Failed to create worker',
        failedUpdate: 'Failed to update worker',
        failedDelete: 'Failed to delete worker',
        active: 'Active',
        inactive: 'Inactive',
        editWorker: 'Edit Worker',
        addNewWorker: 'Add New Worker',
        name: 'Name *',
        phone: 'Phone *',
        email: 'Email',
        role: 'Role',
        selectRole: 'Select role',
        roleWorker: 'Worker',
        roleForeman: 'Foreman',
        roleSupervisor: 'Supervisor',
        roleTechnician: 'Technician',
        activeToggle: 'Active',
        cancel: 'Cancel',
        update: 'Update',
        add: 'Add',
        worker: 'Worker',
        fullNumber: 'Full number:',
        homeAddress: 'Home Address',
        homeAddressPlaceholder: 'Enter worker home address',
        homeAddressHelp: 'Used for route optimization',
    },

    // ─── Jobs ───────────────────────────────────────────────────────────────
    jobs: {
        title: 'Jobs',
        createJob: '+ Create Job',
        filterAll: 'All',
        noJobs: 'No jobs found. Create your first job!',
        loading: 'Loading jobs...',
        deleteConfirm: 'Are you sure you want to delete this job?',
        failedCreate: 'Failed to create job',
        failedUpdate: 'Failed to update job',
        failedDelete: 'Failed to delete job',
        failedAssign: 'Failed to assign technician',
        failedStatus: 'Failed to update status',
        scheduled: 'Scheduled:',
        unassigned: 'Unassigned',
        startJob: 'Start Job',
        complete: 'Complete',
        edit: 'Edit',
        delete: 'Delete',
        editJob: 'Edit Job',
        createNewJob: 'Create New Job',
        customerLabel: 'Customer *',
        selectCustomer: 'Select a customer',
        technicianLabel: 'Technician (optional)',
        jobTitle: 'Job Title *',
        jobTitlePlaceholder: 'AC Repair',
        description: 'Description',
        descriptionPlaceholder: 'Unit not cooling properly...',
        scheduledDateTime: 'Scheduled Date & Time *',
        duration: 'Duration (minutes)',
        price: 'Price ($)',
        cancel: 'Cancel',
        updateJob: 'Update Job',
        createJobBtn: 'Create Job',
        filterUnassigned: 'Unassigned',
        needsTechnician: 'Needs technician',
        waitingFor: 'Waiting for {{name}} to accept',
        accepted: 'Accepted by {{name}}',
        declinedBy: 'Declined by {{name}}',
        declineReason: 'Reason: {{reason}}',
        fromBid: 'From bid',
    },

    // ─── Service Call ─────────────────────────────────────────────────────────
    serviceCall: {
        title: 'New Service Call',
        customerInfo: 'Customer Information',
        jobDetails: 'Job Details',
        customerName: 'Customer Name *',
        customerNamePlaceholder: 'John Smith',
        phone: 'Phone *',
        phonePlaceholder: '050-123-4567',
        email: 'Email *',
        emailPlaceholder: 'customer@email.com',
        address: 'Address',
        addressPlaceholder: '123 Main St, City',
        jobTitle: 'Job Title *',
        jobTitlePlaceholder: 'AC Repair',
        description: 'Description',
        descriptionPlaceholder: 'Unit not cooling properly...',
        scheduledDate: 'Scheduled Date & Time *',
        priority: 'Priority',
        priorityLow: 'Low',
        priorityMedium: 'Medium',
        priorityHigh: 'High',
        technician: 'Technician',
        selectTechnician: 'Select technician (optional)',
        cancel: 'Cancel',
        submit: 'Create Service Call',
        submitting: 'Creating...',
        successTitle: 'Service Call Created!',
        successMessage: 'Job #{{jobId}} has been scheduled',
        customerNew: 'New customer created',
        customerExisting: 'Linked to existing customer',
        done: 'Done',
        error: 'Failed to create service call. Please try again.',
    },

    // ─── Find Service (customer discovery) ──────────────────────────────────
    findService: {
        title: 'Find a Service Provider Near You',
        subtitle: 'Enter your address and preferred time to see available providers in your area',
        yourAddress: 'Your Address',
        addressPlaceholder: 'Enter your address',
        preferredTime: 'Preferred Appointment Time',
        searchBtn: 'Search Providers',
        searching: 'Searching...',
        noResults: 'No providers found in your area. Try a different address.',
        away: 'km away',
        visitFee: 'Visit Fee',
        repairEstimate: 'Repair Estimate',
        call: 'Call',
        forProviders: 'Service provider? Sign in',
        problemLabel: 'Describe your problem',
        problemPlaceholder: 'e.g. AC not cooling, strange noise, water leaking...',
        badge1: 'No commission fees',
        badge2: 'Transparent pricing',
        badge3: 'Certified technicians',
        resultsFound: 'providers found',
        serviceTypeLabel: 'Service Type',
        hvac: 'HVAC / A/C',
        plumbing: 'Plumbing',
        electrical: 'Electricians',
        requestService: 'Request Service',
        yourName: 'Your Name',
        namePlaceholder: 'John Smith',
        yourPhone: 'Your Phone',
        sendRequest: 'Send Request',
        sending: 'Sending...',
        requestSent: 'Request Sent!',
        requestSentSub: 'will contact you shortly.',
        requestError: 'Failed to send request. Please try again.',
        cancelRequest: 'Cancel',
        close: 'Close',
        postJob: 'Post Your Job',
        postJobSub: "We'll send it to nearby providers so they can send you offers",
        postJobBtn: 'Post Job — Get Offers',
        previewBtn: 'Preview Nearby Providers',
    },

    // ─── Service Request Tracking (customer bid tracking page) ──────────────
    requestTracking: {
        title: 'Your Service Request',
        loading: 'Loading your request...',
        notFound: 'This request could not be found.',
        statusOpen: 'Waiting for offers',
        statusAwarded: 'Provider selected',
        statusCancelled: 'Cancelled',
        noBidsYet: 'No offers yet — providers nearby have been notified.',
        bidsHeading: 'Offers received',
        award: 'Choose this provider',
        awarding: 'Selecting...',
        awardedTo: 'You selected {{name}} for this job.',
        eta: 'ETA',
        minutes: 'min',
        refresh: 'Refresh',
    },

    // ─── Leads (org-side, smart dispatching) ─────────────────────────────────
    leads: {
        title: 'Leads',
        subtitle: 'Nearby jobs matching your service area',
        empty: 'No open leads in your area right now.',
        yourBid: 'Your bid',
        priceLabel: 'Your Price (₪)',
        etaLabel: 'ETA (minutes)',
        messageLabel: 'Message to customer',
        submitBid: 'Submit Bid',
        updateBid: 'Update Bid',
        submitting: 'Submitting...',
        bidSubmitted: 'Bid submitted',
        bidAwarded: 'You won this lead',
        bidRejected: 'Awarded to another provider',
        bidError: 'Failed to submit bid. Please try again.',
    },

    // ─── Organization Settings ───────────────────────────────────────────────
    settings: {
        title: 'Settings',
        saving: 'Saving...',
        saved: 'Saved!',
        saveError: 'Error saving, please try again',
        serviceArea: {
            title: 'Service Area',
            current: 'Current address',
            address: 'Business Center Address',
            addressPlaceholder: 'Enter your business address',
            radius: 'Service Radius',
            save: 'Save Service Area',
        },
        pricing: {
            title: 'Pricing',
            visitFee: 'Visit Fee',
            repairMin: 'Repair Estimate Minimum',
            repairMax: 'Repair Estimate Maximum',
            save: 'Save Pricing',
        },
    },

    // ─── Footer ─────────────────────────────────────────────────────────────
    footer: {
        copyright: '© 2026 RouteWise. Field service management software.',
    },

    // ─── Status badges ──────────────────────────────────────────────────────
    status: {
        scheduled: 'Scheduled',
        inProgress: 'In Progress',
        completed: 'Completed',
        cancelled: 'Cancelled',
    },
};

export default en;
